import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderReferrals: build.query<
      GetV2ProviderReferralsApiResponse,
      GetV2ProviderReferralsApiArg
    >({
      query: () => ({ url: `/v2/provider/referrals` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderReferralsApiResponse =
  /** status 200 OK */ ReferralDashboardResponse;
export type GetV2ProviderReferralsApiArg = void;
export type ReferralEntry = {
  /** Credit earned from this referral in dollars (e.g. 0 or 50) */
  credit: number;
  /** Display name of the referred user */
  name?: string | null;
  /** Subscription status: trialing, subscribed, canceled, paused */
  status: string;
};
export type ReferralDashboardResponse = {
  /** User's referral code for sharing */
  referral_code?: string | null;
  /** Cumulative referral earnings (e.g. '$50') */
  referral_earnings?: string;
  /** List of referred users */
  referrals?: ReferralEntry[];
  /** Dollar amount the referrer earns per successful referral (from Stripe coupon) */
  referrer_reward_amount?: number | null;
  /** Dollar amount the referred user gets as a sign-up discount (from Stripe coupon) */
  signup_discount_amount?: number | null;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
